/** Базовое имя файла для загрузки inline-фото — без исходного имени с устройства */
export const MESSENGER_INLINE_IMAGE_UPLOAD_BASENAME = 'image';

/** Расширение по MIME для нейтрального имени (до сжатия / при откате без пережатия) */
function extensionForImageMime(mime: string): string {
  if (mime === 'image/jpeg' || mime === 'image/jpg') return '.jpg';
  if (mime === 'image/png') return '.png';
  if (mime === 'image/gif') return '.gif';
  if (mime === 'image/webp') return '.webp';
  if (mime === 'image/heic' || mime === 'image/heif') return '.heic';
  return '.bin';
}

/** Копия File с нейтральным именем для POST /messenger/upload (превью в чате) */
export function messengerAnonymizedInlineImageFile(file: File): File {
  const ext = extensionForImageMime(file.type || '');
  return new File([file], `${MESSENGER_INLINE_IMAGE_UPLOAD_BASENAME}${ext}`, {
    type: file.type,
    lastModified: file.lastModified,
  });
}
